export { default } from './TypeOfReadingQuizStep';
